import {Component, HostBinding, Input, ViewChild} from '@angular/core';
import {IonSegmentBaseComponent} from 'app/core/ion-components/ionSegment';
import {SwitchRadioCollection} from 'app/entities/switchCollection.entity';
import {SegmentChangeEventDetail} from '@ionic/angular';

@Component({
  selector: 'app-segment',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class SegmentComponent extends IonSegmentBaseComponent {

  @ViewChild('segment') segment: any;

  @Input() collection: SwitchRadioCollection;

  @Input() icon?: string = null;    // icon - параметр на вырост (сейчас не нужен, в будущем понадобится)
  @Input() labelText: string;
  @Input() style: string;

  @HostBinding('class')
  get classes() {
    return {
      [`segment-style-${this.style}`]: this.style,
    };
  }

  onChange(event: CustomEvent<SegmentChangeEventDetail> | any) {
    (this.collection as SwitchRadioCollection).itemSelect(event.detail.value);
    this.forceSegmentChangeAnimation(event.detail.value);
    this.onTouchModel();
  }

  forceSegmentChangeAnimation(newValue) {
    // Костыль чтобы корректно срабатывала анимация переключения сегмента, когда сегмент переключается программно.
    //  (Проблема - если ion-segment запакован внутрь компонента, то при программной смене сегмента, глючит анимация переключения.
    //  Единственное решение без костылей - не помещать Ion-segment в компонент, что в текущем приложении уже проблематично.
    //  Поэтому костыль, который симулирует клик по ion-segment-button, что в свою очередь корректно воспроизводит анимацию переключения).

    const childButtons = this.segment.el.children;
    // console.log('segment', this.segment);
    // console.log('childButtons', childButtons);

    for (const item of childButtons) {
      // console.log(item.value);
      if (item.value === newValue) {
        item.click();
      }
    }
  }

}
